export enum DropdownSearchType {
  Soft = 'soft',
  Input = 'input',
}
